export default __webpack_public_path__ + "static/media/9.a9dc8e48.png";